// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { Action } from '../actions/daysMap';

export type DaysMap = {
  mapState: ('DAYS' | 'GROUPS') | null | undefined;
};
export type State = DaysMap;
export default function currentUser(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: State = {
    mapState: null,
  },
  action: Action
) {
  switch (action.type) {
    case 'SET_MAP_STATE': {
      const { mapState } = action;
      return { ...state, mapState };
    }

    default:
      // this causes a flow error if there are any unhandled actions
      action as never; // eslint-disable-line no-unused-expressions

      return state;
  }
}
